<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    v-bind:class="headerClasses"
  >
    <!--begin::Logo-->
    <a href="/">
      <img alt="Logo" :src="headerLogo" class="header-mobile-logo" />
    </a>
    <!--end::Logo-->
    <!--begin::User Name-->
    <span v-if="currentUserName" class="mobile-header-username">{{ currentUserName }}</span>
    <!--end::User Name-->
    <!--begin::Toolbar-->
    <div class="d-flex align-items-center">
      <!--begin::Mobile Menu Toggle-->
      <button
        class="btn p-0 burger-icon burger-icon-left"
        @click="$emit('open-mobile-menu')"
        aria-label="Mở menu"
      >
        <span></span>
      </button>
      <!--end::Mobile Menu Toggle-->
      <!--begin::Topbar Mobile Toggle-->
      <button
        class="btn btn-hover-text-primary p-0 ml-2"
        id="kt_header_mobile_topbar_toggle"
        ref="kt_header_mobile_topbar_toggle"
      >
        <span class="svg-icon svg-icon-xl">
          <!--begin::Svg Icon | path:svg/icons/General/User.svg-->
          <inline-svg
            class="svg-icon"
            src="/media/svg/icons/General/User.svg"
          />
          <!--end::Svg Icon-->
        </span>
      </button>
      <!--end::Topbar Mobile Toggle-->
    </div>
    <!--end::Toolbar-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KTLayoutHeaderTopbar from '@/assets/js/layout/base/header-topbar.js';

export default {
  name: 'KTHeaderMobile',
  components: {},
  mounted() {
    // Init Header Topbar For Mobile Mode
    KTLayoutHeaderTopbar.init(this.$refs['kt_header_mobile_topbar_toggle']);
  },
  computed: {
    ...mapGetters(['layoutConfig', 'getClasses', 'currentUser']),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig('self.logo.dark');
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    currentUserName() {
      const u = this.currentUser;
      return u?.fullName || u?.name || u?.displayName || u?.userName || null;
    },
    headerClasses() {
      const classes = this.getClasses('header_mobile');
      if (typeof classes !== 'undefined') {
        return classes.join(' ');
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig('aside.self.display');
    },
  },
};
</script>

<style scoped>
.header-mobile-logo {
  height: 36px;
  width: auto;
  display: block;
}
.mobile-header-username {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  text-align: center;
}
</style>
